export default __webpack_public_path__ + "static/media/r200-2.33651095.png";